// extracted by mini-css-extract-plugin
export default {"container":"SelectedPinsSidebar_container__BG9rn","info":"SelectedPinsSidebar_info__be3ez"};